import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("mask", {
  id: "mask0_15381_14147",
  style: {"mask-type":"alpha"},
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "14",
  height: "14"
}, [
  /*#__PURE__*/_createVNode("rect", {
    width: "14",
    height: "14",
    fill: "#D9D9D9"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("g", { mask: "url(#mask0_15381_14147)" }, [
  /*#__PURE__*/_createVNode("path", {
    d: "M2 12.7833V11.6167H12.5V12.7833H2ZM11.0708 9.8375L2 7.25625V3.0125L3.4 3.40625L4.1 5.43333L6.1125 6.00208L5.60208 1L7.27917 1.49583L9.14583 6.87708L11.6542 7.59167C11.8972 7.66945 12.099 7.81042 12.2594 8.01458C12.4198 8.21875 12.5 8.45208 12.5 8.71458C12.5 9.05486 12.3615 9.35382 12.0844 9.61146C11.8073 9.8691 11.4694 9.94444 11.0708 9.8375Z",
    fill: "currentColor"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}